import { Injectable } from '@angular/core'
import { RestServices } from './rest.services'
import { ActivatedRoute, Router } from '@angular/router'
import { Language, User } from '../../models'
import { CookieService } from 'ngx-cookie-service'

@Injectable()

export class AuthService {
    constructor(private checkToken: RestServices, private router: Router, private cookieService: CookieService, private activatedRoute: ActivatedRoute) {
    }

    data: any
    en = {}
    private error = false

    b64EncodeUnicode(str) {
        // return btoa(str);
        return str
    }

    b64DecodeUnicode(str) {
        // return atob(str);
        return str
    }

    // set item data
    setItem(name, data) {
        const Encodedata = this.b64EncodeUnicode(JSON.stringify(data))
        localStorage.setItem(name, JSON.stringify(Encodedata))
    }

    // get item data
    getItem(name) {
        if (localStorage.getItem(name)) {
            return this.b64DecodeUnicode(`${ JSON.parse(localStorage.getItem(name)) }`)
        } else {
            return false
        }
    }

    setUser(user) {
        this.setItem('user', user)
    }

    getUser(): User {
        const user = this.getItem('user')
        if (user) return JSON.parse(user)
    }

    getClientId() {
        return localStorage.getItem('idClient')
    }

    // check auth token - api renew
    authToken() {
        return new Promise((resolve, reject) => {
            const user = this.getUser()
            if (!user)
                this.logout()

            // Task 510: auto log in the app
            // Fix: Reset the token before it was expired 2 minutes
            const expires = (parseInt((user.expiresInSeconds)) - 120) * 1000
            const timeout = parseInt(this.getItem('timeout')) + expires
            const timeNow = Date.now()
            const topUrl = 'account/renew'
            /**
             * check status mobile ?
             * true : logout
             * @type {boolean}
             * appMobile routeConfig
             */
            const statusMobile = user.appMobile
            if (this.router.url.includes('client')) {
                if (!statusMobile && this.activatedRoute.snapshot.children[0].url[0].path === 'client') {

                    let resourceData = {
                        line_code: "service/auth.service.ts line 76",
                        reason: "user.appMobile " + statusMobile,
                        token: this.getItem('token'),
                        date: Date.now()
                    }
                    this.checkToken.http_post('account/clientLog', resourceData, this.getItem('token')).subscribe(res => {
                        console.log('logcatch ogout in client')
                        localStorage.removeItem('user')
                        localStorage.removeItem('token')
                        localStorage.removeItem('timeout')
                        this.cookieService.delete('token')
                        localStorage.removeItem('device_token')
                        this.router.navigateByUrl('client/login-token')
                        reject('error')
                    })

                    //localStorage.removeItem('user')
                    //localStorage.removeItem('token')
                    //localStorage.removeItem('timeout')
                    //this.cookieService.delete('token')
                    //return this.router.navigateByUrl('/client/login-token')
                }
                if (!statusMobile && this.activatedRoute.snapshot.children[0].children[0].routeConfig.path === 'device') {
                    return this.router.navigateByUrl('/app/login')
                }
            }

            if (timeout <= timeNow) {
                if (user.clientDeviceId && this.activatedRoute.snapshot.children[0].url[0].path === 'client') {
                    const checkRenew = this.checkToken.http_post(topUrl, null, this.getItem('token')).toPromise().then(success => {
                        this.setItem('user', success)
                        this.setItem('token', this.getUser().token)
                        this.setItem('timeout', Date.now())
                        this.cookieService.set('token', success['token'], 1)
                        const data = JSON.parse(this.getItem('token'))
                        return data
                    }, err => {
                        if (err.status === 401) {
                            localStorage.removeItem('user')
                            localStorage.removeItem('token')
                            localStorage.removeItem('timeout')
                            this.cookieService.delete('token')
                            this.router.navigateByUrl('/app/login')
                        }
                    })
                    checkRenew.then(data => {
                        if (this.error) {
                            reject('error')
                        } else {
                            resolve(this.getItem('token'))
                        }
                    })
                } else {
                    this.logout()
                }
            } else {
                if (this.error) {
                    reject('error')
                } else {
                    // Check Device
                    if (user.clientDeviceId) {
                        if (statusMobile && this.activatedRoute.snapshot.children[0].url[0].path === 'client') {
                            const deviceUrl = 'account/clientDeviceExists'
                            this.checkToken.http_post(deviceUrl, null, this.getItem('token')).subscribe(res => {
                                //
                                if (!res['accountExists']) {
                                    let resourceData = {
                                        line_code: "service/auth.service.ts line 126",
                                        reason: "Device not exist/Device removed",
                                        token: this.getItem('token'),
                                        date:  Date.now()
                                    }
                                    this.checkToken.http_post('account/clientLog', resourceData, this.getItem('token')).subscribe(res => {
                                        console.log('logcatch ogout in client')
                                        localStorage.removeItem('user')
                                        localStorage.removeItem('token')
                                        localStorage.removeItem('timeout')
                                        this.cookieService.delete('token')
                                        localStorage.removeItem('device_token')
                                        this.router.navigateByUrl('client/login-token')
                                        reject('error')
                                    })

                                    return
                                } else {
                                    this.cookieService.set('token', this.getItem('token'), 1)
                                    resolve(this.getItem('token'))
                                }
                            }, err => {
                                if (err.status === 401) {
                                    let resourceData = {
                                        line_code: "service/auth.service.ts line 168",
                                        reason: "Call api clientDeviceExists failed",
                                        token: this.getItem('token'),
                                        date:  Date.now()
                                    }
                                    this.checkToken.http_post('account/clientLog', resourceData, this.getItem('token')).subscribe(res => {
                                        console.log('logcatch ogout in client')
                                        localStorage.removeItem('user')
                                        localStorage.removeItem('token')
                                        localStorage.removeItem('timeout')
                                        this.cookieService.delete('token')
                                        localStorage.removeItem('device_token')
                                        this.router.navigateByUrl('client/login-token')
                                        reject('error')
                                    })
                                }
                            })
                        }
                    } else {
                        this.cookieService.set('token', this.getItem('token'), 1)
                        resolve(this.getItem('token'))

                    }
                }
            }
        })
    }

    // languge
    showLang(showEN) {
        const Lang = new Language()
        const lang_default = localStorage.getItem('lang')
        if (lang_default) {
            if (lang_default === 'true') {
                return this.en = Lang.arrEn
            } else {
                return this.en = Lang.arrJAN
            }
        } else {
            return this.en = (showEN ? Lang.arrEn : Lang.arrJAN)
        }
    }

    getToken() {
        return this.getUser().token
    }

    getLang() {
        const lang = localStorage.getItem('lang')
        if (lang) {
            if (lang === 'true') {
                return 'en'
            } else {
                return 'jp'
            }
        } else {
            return 'en'
        }
    }

    getPaymentLang() {
        const lang = localStorage.getItem('lang')
        if (lang) {
            if (lang === 'true') {
                return 'en'
            } else {
                return 'ja'
            }
        } else {
            return 'en'
        }
    }

    getLocale() {
        const lang = this.getLang()
        const Lang = new Language()

        if (lang === 'en') {
            return Lang.arrEn
        } else {
            return Lang.arrJAN
        }
    }

    logout() {
        localStorage.removeItem('user')
        localStorage.removeItem('token')
        localStorage.removeItem('timeout')
        this.cookieService.delete('token')
        jQuery('body').attr('class', 'blue')
        localStorage.removeItem('urlLogo')
        localStorage.removeItem('classThemeBody')
        return this.router.navigateByUrl('/app/login')
    }
}



// WEBPACK FOOTER //
// ./src/app/services/auth.services.ts